'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var PageSize = /** @class */ (function () {
    function PageSize() {
    }
    PageSize.createNullObject = function () {
        var data = new PageSize();
        data.height = 0;
        data.width = 0;
        return data;
    };
    PageSize.create = function (height, width) {
        var data = new PageSize();
        data.height = height;
        data.width = width;
        return data;
    };
    return PageSize;
}());

var PDFJSViewer = require("pdfjs-dist/web/pdf_viewer");
var PDFJSThumbnailViewer = require("pdfjs-dist/lib/web/pdf_thumbnail_viewer");
var PDFJSOutlineViewer = require("pdfjs-dist/lib/web/pdf_outline_viewer");
var PDFJSLinkService = require("pdfjs-dist/lib/web/pdf_link_service");
(function (ViewerMode) {
    ViewerMode[ViewerMode["Normal"] = 0] = "Normal";
    ViewerMode[ViewerMode["Read"] = 1] = "Read";
})(exports.ViewerMode || (exports.ViewerMode = {}));
(function (PageMode) {
    PageMode[PageMode["SinglePage"] = 1] = "SinglePage";
    PageMode[PageMode["MultiPage"] = 2] = "MultiPage";
    PageMode[PageMode["Classic"] = 3] = "Classic";
})(exports.PageMode || (exports.PageMode = {}));
var PageMatchesCount = /** @class */ (function () {
    function PageMatchesCount() {
    }
    PageMatchesCount.createNullObject = function () {
        var data = new PageMatchesCount();
        data.page = 0;
        data.matchCount = 0;
        return data;
    };
    PageMatchesCount.create = function (page, matchCount) {
        var data = new PageMatchesCount();
        data.page = page;
        data.matchCount = matchCount;
        return data;
    };
    return PageMatchesCount;
}());
var SearchResult = /** @class */ (function () {
    function SearchResult() {
    }
    SearchResult.createNullObject = function () {
        var data = new SearchResult();
        data.matchCount = 0;
        data.pagesMatch = [];
        return data;
    };
    SearchResult.create = function (matchesCount, pagesMatches) {
        var data = new SearchResult();
        data.matchCount = matchesCount;
        data.pagesMatch = pagesMatches;
        return data;
    };
    return SearchResult;
}());
var PdfSource = /** @class */ (function () {
    function PdfSource() {
    }
    PdfSource.createNullObject = function () {
        return new PdfSource();
    };
    PdfSource.createFromUrl = function (url) {
        var data = new PdfSource();
        data.url = url;
        return data;
    };
    PdfSource.createFromBase64 = function (base64String) {
        var data = new PdfSource();
        data.base64String = base64String;
        return data;
    };
    return PdfSource;
}());
var PdfJSSource = /** @class */ (function (_super) {
    __extends(PdfJSSource, _super);
    function PdfJSSource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PdfJSSource.createPDFDocumentProxy = function (pdfDocumentProxy) {
        var data = new PdfJSSource();
        data.pdfDocumentProxy = pdfDocumentProxy;
        return data;
    };
    return PdfJSSource;
}(PdfSource));
var ViewerBase = /** @class */ (function () {
    function ViewerBase() {
        var _this = this;
        this.getEventBus = function () {
            _this._eventBus = new PDFJSViewer.EventBus();
            return _this._eventBus;
        };
        this.getCurrentPage = function () {
            return _this._pdfViewer.currentPageNumber;
        };
        this.gotoPage = function (page) {
            _this._pdfViewer.currentPageNumber = page;
        };
        this.getPageSize = function (page) {
            var currentPage = _this._pdfViewer._pages[page - 1];
            if (currentPage != null) {
                return PageSize.create(currentPage.viewport.height / currentPage.viewport.scale, currentPage.viewport.width / currentPage.viewport.scale);
            }
            else {
                return PageSize.createNullObject();
            }
        };
        this.setScale = function (scale) {
            _this._pdfViewer.currentScale = scale;
        };
        this.getCurrentScale = function () {
            return _this._pdfViewer.currentScale;
        };
        this.getTotalPages = function () {
            return _this._pdfViewer.pagesCount;
        };
        this.getBookmark = function (page) {
            var pageObj = _this._bookmarkViewer.outline && _this._bookmarkViewer.outline[page - 1];
            if (pageObj) {
                return pageObj.title;
            }
            return "";
        };
        this.scrollThumbnailIntoView = function (page) {
            _this._thumbnailViewer &&
                _this._thumbnailViewer.scrollThumbnailIntoView(page);
        };
        this.findText = function (textToFind) {
            var _self = _this;
            _this._pdfFindController.executeCommand("find", {
                query: textToFind,
                caseSensitive: false,
                entireWord: false,
                findPrevious: undefined,
                highlightAll: true,
                phraseSearch: true
            });
            var promise = new Promise(function (resolve) {
                window.setTimeout(function () {
                    var pages = [];
                    _self._pdfFindController._pageMatches.forEach(function (item, index) {
                        item.length > 0 &&
                            pages.push(PageMatchesCount.create(index + 1, item.length)); // adding pages and matched count
                    });
                    var searchResult = SearchResult.create(_self._pdfFindController._matchesCountTotal, pages);
                    resolve(searchResult);
                }, 1000);
            });
            return promise;
        };
        this.initializeLinkService();
    }
    ViewerBase.create = function () {
        return new ViewerBase();
    };
    ViewerBase.prototype.initializePdfFindController = function () {
        this._pdfFindController = new PDFJSViewer.PDFFindController({
            eventBus: this._eventBus,
            linkService: this._pdfLinkService
        });
    };
    ViewerBase.prototype.initializeViewer = function (container, pageMode, disableTextLayer) {
        if (pageMode == exports.PageMode.SinglePage) {
            this._pdfViewer = new PDFJSViewer.PDFSinglePageViewer({
                container: container,
                linkService: this._pdfLinkService,
                eventBus: this._eventBus,
                findController: this._pdfFindController,
                textLayerMode: disableTextLayer ? 0 : 1
            });
        }
        else {
            this._pdfViewer = new PDFJSViewer.PDFViewer({
                container: container,
                linkService: this._pdfLinkService,
                eventBus: this._eventBus,
                findController: this._pdfFindController,
                textLayerMode: disableTextLayer ? 0 : 1,
                renderInteractiveForms: false
            });
        }
        this._pdfLinkService.setViewer(this._pdfViewer);
    };
    ViewerBase.prototype.initializeThumbnailViewer = function (container) {
        if (container) {
            this._thumbnailViewer = new PDFJSThumbnailViewer.PDFThumbnailViewer({
                container: container,
                linkService: this._pdfLinkService,
                renderingQueue: this._pdfViewer.renderingQueue
            });
            this._pdfViewer.renderingQueue.isThumbnailViewEnabled = true;
            this._pdfViewer.renderingQueue.setThumbnailViewer(this._thumbnailViewer);
        }
    };
    ViewerBase.prototype.initializeBookmarkViewer = function (container) {
        if (container) {
            this._bookmarkViewer = this._bookmarkViewer;
            this._bookmarkViewer = new PDFJSOutlineViewer.PDFOutlineViewer({
                container: container,
                linkService: this._pdfLinkService,
                eventBus: this._eventBus,
                initialViewState: "outline"
            });
        }
    };
    ViewerBase.prototype.initializeLinkService = function () {
        this._pdfLinkService = new PDFJSLinkService.PDFLinkService();
    };
    ViewerBase.prototype.setDocument = function (document) {
        this._pdfViewer.setDocument(document);
        if (this._thumbnailViewer) {
            this._thumbnailViewer.setDocument(document);
            this.renderBookmarkList(document);
        }
        this._pdfLinkService.setDocument(document, null);
    };
    ViewerBase.prototype.setPdfPage = function (container, document, page, scale, disableTextLayer, renderInteractiveForms, onAfterDraw) {
        var _self = this;
        var promise = new Promise(function (resolve) {
            document.getPage(page).then(function (pdfPage) {
                container.innerHTML = "";
                _self._pdfViewer = new PDFJSViewer.PDFPageView({
                    eventBus: _self._eventBus,
                    // linkService: _self._pdfLinkService,
                    container: container,
                    id: page,
                    scale: scale,
                    defaultViewport: pdfPage.getViewport(page),
                    renderInteractiveForms: renderInteractiveForms == undefined ? true : renderInteractiveForms,
                    // findController: _self._pdfFindController,
                    textLayerMode: disableTextLayer ? 0 : 1,
                    textLayerFactory: new PDFJSViewer.DefaultTextLayerFactory(),
                    onAfterDraw: onAfterDraw
                });
                _self._pdfViewer.setPdfPage(pdfPage);
                _self._pdfViewer.draw();
                resolve(page);
            });
        });
        return promise;
    };
    ViewerBase.prototype.renderBookmarkList = function (document) {
        var _self = this;
        document.getOutline().then(function (outline) {
            _self._bookmarkViewer.render({ outline: outline });
        });
    };
    return ViewerBase;
}());

exports.PDFJSViewer = PDFJSViewer;
exports.PageMatchesCount = PageMatchesCount;
exports.SearchResult = SearchResult;
exports.PdfSource = PdfSource;
exports.PdfJSSource = PdfJSSource;
exports.default = ViewerBase;
